import {equals} from 'ramda'

/** Whether the server value of any of the inputs the user changed differs from the snapshot */
export const hasConflictingChanges = (
  snapshot: Record<string, any>,
  current: Record<string, any>,
  changedInputs: string[]
): boolean => changedInputs.some(name => !equals(snapshot?.[name], current?.[name]))
